export default "__VITE_ASSET__DRxTeb7v__"